import React, {useRef} from "react";
import "./SubmitInfo.scss";
import intl from "react-intl-universal";

export function SubmitInfo() {
    const contactForm = useRef();

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        const {t0, t1, t2, t3} = contactForm.current;
        const $ = window.$;
        $.post("http://www.gzrebornendo.com/submit.php", {
            t0: t0.value,
            t1: t1.value,
            t2: t2.value,
            t3: t3.value
        }, function (res) {
            if (res.status === "ok") {
                alert("预约成功！")
            } else {
                alert("预约失败！")
            }
        })
    }

    return <>
        <div className="in_price">
            <div className="f_form">
                <div className="title">
                    <h3>{intl.get('get-more')}</h3>
                </div>
                <form ref={contactForm} onSubmit={handleSubmit} id="contact_form" className="page_form wpcf7-form"
                      name="contact_form" method="post">

                    <div className="input"><input type="text" name="t0" aria-required="true"
                                                  aria-invalid="false" placeholder={intl.get('name')}/></div>
                    <div className="input"><input type="email" name="t1" aria-required="true"
                                                  aria-invalid="false" placeholder={intl.get('email')}/></div>
                    <div className="input"><input type="text" name="t2" aria-invalid="false" placeholder={intl.get('phone')}/>
                    </div>
                    <div className="input"><input type="text" name="t3" aria-invalid="false" placeholder={intl.get('notes')}/>
                    </div>


                    <div className="submit"><input type="submit" value={intl.get('commit')}
                                                   className="wpcf7-form-control wpcf7-submit fh-btn"/></div>
                </form>
                <i style={{fontStyle: 'italic'}}>*{intl.get('tips')}</i>
            </div>
        </div>
    </>
}
